import _ from 'lodash';

/**
 *
 * @returns {ThunkAction}
 */
export function toggleShow(show = true) {
  return (dispatch) => {
    dispatch({ type: 'TOAST_SET_SHOW', show });
  };
}

/**
 *
 * @returns {ThunkAction}
 */
export function setComponent(component) {
  return (dispatch) => {
    dispatch({ type: 'TOAST_SET_COMPONENT', component });
  };
}

/**
 *
 * @returns {ThunkAction}
 */
export function toast(component) {
  return (dispatch) => {
    dispatch(setComponent(component));
    dispatch(toggleShow(true));
  };
}
